"use strict";
/**
 * @file: 集成 immer、并真正利用 namespace
 * @author: yangqianjun
 * @Date: 2019-12-20 09:32:15
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-20 12:04:33
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var createModel_1 = tslib_1.__importDefault(require("./createModel"));
function CM(model) {
    // cheat
    return createModel_1.default(tslib_1.__assign(tslib_1.__assign({}, model), { m: 0 /* ReduxModern */ }));
}
exports.CM = CM;
//# sourceMappingURL=cm.js.map